module.exports = __webpack_public_path__ + "img/vue2-toebox_vert.a9ca7d15.png";